import React, { useState } from "react";
import { displayIcon } from "variables/icons";
import HolidayCalendar from "./HolidayCalendar";
import CustomTabs from "components/tabs/customTab";
import HolidayTable from "./HolidayTable";

const HolidayTab = ({ }) => {

	const [activeTab, setActiveTab] = useState("HolidayCalendar");
	const TabLabel = ({ icon, text }) => (
		<div className="flex items-center justify-center gap-2">
			{displayIcon(icon, "icon-item")}
			<span className="text-sm font-medium">{text}</span>
		</div>
	);

	const tabOptions = [
		{
			label: <TabLabel icon="Calendar1" text="Holiday Calendar" />,
			value: "HolidayCalendar",
		},
		{
			label: <TabLabel icon="CalendarDays" text="Holiday List" />,
			value: "HolidayList",
		},
	];
	
  	return (
        <div className="space-y-6">
            <CustomTabs
                tabs={tabOptions}
                activeTab={activeTab}
                onChange={setActiveTab}
				height="h-10"
            />

            <>
                {activeTab === "HolidayCalendar" && (
                <>
                    <HolidayCalendar />
                </>
                )}

                {activeTab === "HolidayList" && (
                    <HolidayTable recordId={0}/>
                )}
            </>
        </div>
  );
};

export default HolidayTab;
